import { TachoReleaseInformationModel } from '../../../../core/domainModels/versions/TachoInstallerModel';
import { UpdateTachoInstallerModel } from '../../../../core/domainModels/versions/UpdateTachoInstallerModel';

export const mapTachoInstallerToAddTachoInstaller = (installer: TachoReleaseInformationModel): UpdateTachoInstallerModel => {
    return {
        tachoReleaseInformationId: installer.id,
        patchNotes: installer.patchNotes,
        releaseDate: installer.releaseDate,
        releaseType: installer.releaseType,
        versionMajor: installer.version?.major || 0,
        versionMinor: installer.version?.minor || 0,
        versionPatch: installer.version?.patch || 0,
        MD5: installer.MD5 ?? '',
        SHA256: installer.SHA256 ?? '',
        size: installer.size,
        isBeta: installer.isBeta,
        variant: installer.variant ?? '',
    };
};

export const versionsModalTableHeight = 500;
